// The permissions grouped by area, each with a tick box, and "Grant all" / "Remove all" per group.
// Used by the practice role editor, a person's exceptions, and the CatTrax role-defaults screen.
app.component("permissionChecklist", {
	templateUrl: "app/src/js/components/permissions/permissionChecklist.html",
	controller: "permissionChecklistController",
	bindings: {
		// From PermissionAPI.getCatalogue().
		catalogue: "<",
		// { PERMISSION_NAME: true/false } - what is ticked. Changed in place.
		selected: "<",
		// What it would be without this change. A permission that differs is marked "Changed".
		starting: "<",
		// The practice's paid features. Leave out for CatTrax, which can change anything.
		enabledFeatures: "<",
		// Only CatTrax can change the locked permissions.
		canChangeLocked: "<",
		readOnly: "<",
		// Optional { PERMISSION_NAME: "why they have it" }, shown next to each permission.
		reasons: "<",
		startingLabel: "@",
	},
});

app.controller("permissionChecklistController", [
	function () {
		var $ctrl = this;
		// Groups start folded so the one you want is a click away instead of a long scroll. Kept by
		// group code, so a group stays open while you move between people or roles.
		var open = {};

		$ctrl.isOpen = function (group) {
			return !!open[group.code];
		};

		$ctrl.toggle = function (group) {
			open[group.code] = !open[group.code];
		};

		$ctrl.setAllOpen = function (isOpen) {
			$ctrl.groups.forEach(function (group) {
				open[group.code] = isOpen;
			});
		};

		$ctrl.countChanged = function (group) {
			return group.permissions.filter($ctrl.isChanged).length;
		};

		$ctrl.$onChanges = function () {
			$ctrl.groups = [];
			var byGroup = {};
			(($ctrl.catalogue) || []).forEach(function (permission) {
				if (!byGroup[permission.group]) {
					byGroup[permission.group] = { code: permission.group, label: permission.group_label, permissions: [] };
					$ctrl.groups.push(byGroup[permission.group]);
				}
				byGroup[permission.group].permissions.push(permission);
			});
		};

		$ctrl.isPaidFor = function (permission) {
			return !$ctrl.enabledFeatures
				|| permission.features.length === 0
				|| permission.features.some(function (feature) {
					return $ctrl.enabledFeatures.indexOf(feature) !== -1;
				});
		};

		$ctrl.isLocked = function (permission) {
			return permission.locked_for_practices && !$ctrl.canChangeLocked;
		};

		$ctrl.canChange = function (permission) {
			return !$ctrl.readOnly && !$ctrl.isLocked(permission) && $ctrl.isPaidFor(permission);
		};

		$ctrl.isChanged = function (permission) {
			var wasOn = ($ctrl.starting || []).indexOf(permission.name) !== -1;
			return !!$ctrl.selected[permission.name] !== wasOn;
		};

		$ctrl.reset = function (permission) {
			$ctrl.selected[permission.name] = ($ctrl.starting || []).indexOf(permission.name) !== -1;
		};

		// Skips anything locked or not paid for, as the server would refuse it.
		$ctrl.setGroup = function (group, on) {
			group.permissions.forEach(function (permission) {
				if ($ctrl.canChange(permission)) {
					$ctrl.selected[permission.name] = on;
				}
			});
		};

		$ctrl.countOn = function (group) {
			return group.permissions.filter(function (permission) {
				return $ctrl.selected[permission.name];
			}).length;
		};

		$ctrl.featureLabel = function (permission) {
			return permission.features.map(function (feature) {
				return feature.toLowerCase().replace(/_/g, " ");
			}).join(" or ");
		};
	},
]);
